import React from 'react';
import { Button, Flex, Input, Text } from "@chakra-ui/react";
import { Form } from "react-final-form";
import { fpEmailConfig, fpResetPasswordConfig, fpTokenConfig } from "../config";
import { useRef, useEffect, useState } from 'react';
import { LoginPropTypes } from "../PayRentPropTypes";
import { FormField, SubmitButton } from "../../../components/form";
import { FormApi } from "final-form";
import { localisable } from "../../../generic/localisable";
import { emailFormButtonProps, formMainContainerCommonProps, fpEmailFormProps } from "../constants";
import { renderErrorContainer } from "../Utils";
import { navigate } from "gatsby-link";


export const ForgotPasswordEmailForm = ({ forgotPasswordEmailError, onSubmitEmailForm }: LoginPropTypes.TFpEmailFormProps) => {

    const formProps = useRef({});
    const { email } = fpEmailConfig();
    const [isEmailErrorExists, setIsEmailErrorExists] = useState(false);

    useEffect(() => {
        if (forgotPasswordEmailError) {
            setIsEmailErrorExists(true);
        }
    }, [forgotPasswordEmailError]);

    const onSubmit = (form: FormApi) => {
        onSubmitEmailForm(form);
    }

    const renderForm = (currentFormProps: any) => {

        const { touched = {}, errors = {} } = currentFormProps || {};
        const { email: touchedEmail } = touched;
        const { email: errorEmail } = errors;
        const alignItemsStyle = (touchedEmail && errorEmail) ? 'center' : 'flex-end';

        return (
            <Flex direction='column' gap='24px'>
                {isEmailErrorExists && renderErrorContainer(forgotPasswordEmailError, setIsEmailErrorExists)}
                <Flex direction={{ base: 'column', sm: 'row' }} gap='32px' alignItems={{ sm: alignItemsStyle }}>
                    <FormField {...email} {...currentFormProps} >
                        <Input />
                    </FormField>
                    <Flex direction={{ base: 'column', sm: 'row' }} gap='16px' alignItems={{ sm: 'flex-end' }}>
                        <Button
                            {...emailFormButtonProps}
                            onClick={() => navigate(-1)}
                            bg='brand.lightTertiary'
                        >
                            <Text textStyle='buttonSmall' color='common.white' >{localisable.goBack}</Text>
                        </Button>
                        <SubmitButton
                            formProps={currentFormProps}
                            label={localisable.send}
                            {...emailFormButtonProps}
                        />
                    </Flex>
                </Flex>
            </Flex>
        )
    }

    return (
        <Flex {...fpEmailFormProps}>
            <Form
                onSubmit={onSubmit}
                initialValues={{ email: '' }}
                render={(currentFormProps) => {
                    const { handleSubmit, ...restFormProps } = currentFormProps;
                    formProps.current = restFormProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            {renderForm(currentFormProps)}
                        </form>
                    )
                }}
            />
        </Flex>
    )
};


export const ForgotPasswordTokenForm = ({ forgotPasswordTokenError, onSubmitTokenForm }: LoginPropTypes.TFpTokenFormProps) => {

    const formProps = useRef({});
    const { email, token } = fpTokenConfig();
    const [isTokenErrorExists, setIsTokenErrorExists] = useState(false);

    useEffect(() => {
        if (forgotPasswordTokenError) {
            setIsTokenErrorExists(true);
        }
    }, [forgotPasswordTokenError]);

    const onSubmit = (form: FormApi) => {
        onSubmitTokenForm(form);
    }

    const renderForm = (currentFormProps: any) => {

        return (
            <Flex direction='column' gap='24px' justifyContent='center'>
                <FormField {...email} {...currentFormProps} >
                    <Input />
                </FormField>
                <FormField {...token} {...currentFormProps} >
                    <Input />
                </FormField>
                <Flex direction={{ base: 'column', sm: 'row' }} gap='16px' justifyContent={{ sm: 'flex-end' }}>
                    <Button
                        {...emailFormButtonProps}
                        onClick={() => navigate(-1)}
                        bg='button.blue'
                        minW={{ base: '100%', sm: '204px' }}
                    >
                        <Text textStyle='buttonSmall' color='common.white' >{localisable.goBack}</Text>
                    </Button>
                    <SubmitButton
                        formProps={currentFormProps}
                        label={localisable.verifyCode}
                        {...emailFormButtonProps}
                        minW={{ base: '100%', sm: '204px' }}
                    />
                </Flex>
            </Flex>
        )
    }

    return (
        <Flex direction='column' {...formMainContainerCommonProps}>
            {isTokenErrorExists && renderErrorContainer(forgotPasswordTokenError, setIsTokenErrorExists)}
            <Form
                onSubmit={onSubmit}
                initialValues={{ email: '', token: '' }}
                render={(currentFormProps) => {
                    const { handleSubmit, ...restFormProps } = currentFormProps;
                    formProps.current = restFormProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            {renderForm(currentFormProps)}
                        </form>
                    )
                }}
            />
        </Flex>
    )
};


export const ResetPasswordForm = ({ forgotPasswordResetError, onSubmitResetPasswordForm }: LoginPropTypes.TFpResetPasswordFormProps) => {

    const formProps = useRef({});
    const { email, password, repeatPassword } = fpResetPasswordConfig();
    const [isResetPasswordErrorExists, setIsResetPasswordErrorExists] = useState(false);

    useEffect(() => {
        if (forgotPasswordResetError) {
            setIsResetPasswordErrorExists(true);
        }
    }, [forgotPasswordResetError]);

    const onSubmit = (form: FormApi) => {
        onSubmitResetPasswordForm(form);
    }

    const renderForm = (currentFormProps: any) => {

        return (
            <Flex direction='column' gap='24px' justifyContent='center'>
                <FormField {...email} {...currentFormProps} >
                    <Input />
                </FormField>
                <FormField {...password} {...currentFormProps} >
                    <Input />
                </FormField>
                <FormField {...repeatPassword} {...currentFormProps} >
                    <Input />
                </FormField>
                <Flex direction={{ base: 'column', sm: 'row' }} gap='16px' justifyContent={{ sm: 'flex-end' }}>
                    <Button
                        {...emailFormButtonProps}
                        onClick={() => navigate(-1)}
                        bg='button.blue'
                        minW={{ base: '100%', sm: '204px' }}
                    >
                        <Text textStyle='buttonSmall' color='common.white' >{localisable.goBack}</Text>
                    </Button>
                    <SubmitButton
                        formProps={currentFormProps}
                        label={localisable.reset}
                        {...emailFormButtonProps}
                        minW={{ base: '100%', sm: '204px' }}
                    />
                </Flex>
            </Flex>
        )
    }

    return (
        <Flex direction='column' {...formMainContainerCommonProps}>
            {isResetPasswordErrorExists && renderErrorContainer(forgotPasswordResetError, setIsResetPasswordErrorExists)}
            <Form
                onSubmit={onSubmit}
                initialValues={{ email: '', password: '', repeatPassword: '' }}
                render={(currentFormProps) => {
                    const { handleSubmit, ...restFormProps } = currentFormProps;
                    formProps.current = restFormProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            {renderForm(currentFormProps)}
                        </form>
                    )
                }}
            />
        </Flex>
    )
};